module.exports = __webpack_public_path__ + "media/video.d97a8714.mp4";